import React from "react";
import PremiumResourcePage, { resourceStatus } from "../../../Components/Dashboard/PremiumResourcePage";
import VendorDetails from "../SalesNew/VendorDetails";
import VendorsUpdate from "./VendorsUpdate";

function Vendors({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Vendors"
      subtitle="Manage supplier profiles, contact details, and payment terms."
      createRoute="VendorsNew"
      createLabel="+ New Vendor"
      fetchEndpoint="/fetchVendors"
      deleteEndpoint="/deleteVendor"
      deleteMethod="POST"
      deleteKey="id"
      transformRows={(rows) =>
        rows.map((row) => ({
          ...row,
          vendorName: row.vendorName || row.vendorDisplayName,
          vendorDisplayName: row.vendorDisplayName || row.vendorName,
        }))
      }
      renderEdit={(row, handleCancel) => (
        <VendorsUpdate id={row.id} handleCancle={handleCancel} />
      )}
      renderDetail={(row, handleCancel) => (
        <VendorDetails
          newVendorId={row.id}
          fetchedPaymentTerms={row.paymentTerms}
          handleCancel={handleCancel}
        />
      )}
      columns={[
        { key: "serial", label: "Serial No." },
        {
          key: "vendorName",
          label: "Name",
          className: "premium-link-cell",
          render: (row) => (
            <button className="premium-link" type="button">
              {row.vendorName || row.vendorDisplayName || "-"}
            </button>
          ),
        },
        { key: "companyName", label: "Company Name" },
        { key: "vendorEmail", label: "Email" },
        { key: "status", label: "Status", render: (row) => resourceStatus(row.status || "Active") },
        { key: "paymentTerms", label: "Payment Terms" },
      ]}
    />
  );
}

export default Vendors;
